// extracted by mini-css-extract-plugin
module.exports = {"vGray2":"#f4f5f7","block":"ReportList_block__36D0G","list":"ReportList_list__2Xr8B"};